<template>
  <v-dialog v-model="show" max-width="800">
    <v-card>
      <v-card-title>
        {{ $vuetify.lang.t('$vuetify.VEHICLE_GROUPS.LICENSE_PLATES') }}
        <v-spacer></v-spacer>
        <vue-xlsx-table
          style="background-color: 'red'"
          @on-select-file="onFileSelect"
        >
          <v-menu offset-y dense>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon small v-bind="attrs" v-on="on">
                <v-icon>mdi-dots-horizontal</v-icon>
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item @click="downloadTemplateFile()">
                <v-list-item-title>
                  <v-icon small class="mr-2">mdi-download</v-icon>
                  {{ $vuetify.lang.t('$vuetify.DOWNLOAD_TEMPLATE_FILE') }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <v-btn small text color="dark">
            <v-icon class="mr-2">mdi-file-import</v-icon>
            {{ $vuetify.lang.t('$vuetify.IMPORT_FROM_FILE') }}
          </v-btn>
        </vue-xlsx-table>
      </v-card-title>
      <v-card-text>
        <v-row class="d-flex align-center">
          <v-col cols="8">
            <v-text-field
              v-model="newLicensePlate"
              :label="
                $vuetify.lang.t(
                  '$vuetify.VEHICLE_GROUPS.ENTER_NEW_LICENSE_PLATE'
                )
              "
              dense
              outlined
              hide-details
              placeholder="123ABC"
              class="d-flex align-center"
              @keyup.enter="addLicensePlate"
            >
              <template v-slot:append-outer>
                <v-btn
                  color="primary"
                  :disabled="!newLicensePlate"
                  @click="addLicensePlate"
                >
                  {{ $vuetify.lang.t('$vuetify.ADD') }}
                </v-btn>
              </template>
            </v-text-field>
            <v-checkbox
              v-model="removePlatesNotInRequest"
              :label="
                $vuetify.lang.t(
                  '$vuetify.VEHICLE_GROUPS.REMOVE_EXISTING_VEHICLES'
                )
              "
              hide-details
              class="ma-0"
            ></v-checkbox>
          </v-col>
        </v-row>

        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">
                  {{ $vuetify.lang.t('$vuetify.VEHICLE_GROUPS.LICENSE_PLATE') }}
                </th>
                <th class="text-right"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in vehicleGroupLicensePlates" :key="item.ID">
                <td>
                  <div
                    v-if="
                      !licensePlateInEditMode ||
                        licensePlateInEditMode.ID !== item.ID
                    "
                  >
                    {{ item.licensePlate }}
                  </div>
                  <div
                    v-if="
                      licensePlateInEditMode &&
                        licensePlateInEditMode.ID === item.ID
                    "
                  >
                    <v-text-field
                      ref="licensePlateInput"
                      :value="item.licensePlate"
                      dense
                      hide-details
                      @keyup.enter="saveLicensePlate(item)"
                      @keyup.esc="cancelEdit(item)"
                    ></v-text-field>
                  </div>
                </td>
                <td class="d-flex align-center justify-end">
                  <v-tooltip
                    v-if="
                      !licensePlateInEditMode ||
                        licensePlateInEditMode.ID !== item.ID
                    "
                    top
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn
                        icon
                        @click="licensePlateInEditMode = item"
                        v-on="on"
                      >
                        <v-icon small>mdi-pencil</v-icon>
                      </v-btn>
                    </template>
                    <span>
                      {{ $vuetify.lang.t('$vuetify.EDIT') }}
                    </span>
                  </v-tooltip>
                  <v-tooltip
                    v-if="
                      licensePlateInEditMode &&
                        licensePlateInEditMode.ID === item.ID
                    "
                    top
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn
                        icon
                        color="success"
                        @click="saveLicensePlate(item)"
                        v-on="on"
                      >
                        <v-icon small>mdi-check</v-icon>
                      </v-btn>
                    </template>
                    <span>
                      {{ $vuetify.lang.t('$vuetify.EDIT') }}
                    </span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        icon
                        @click="onLicensePlateDeleteClick(item)"
                        v-on="on"
                      >
                        <v-icon small color="error">mdi-delete</v-icon>
                      </v-btn>
                    </template>
                    <span>
                      {{ $vuetify.lang.t('$vuetify.DELETE') }}
                    </span>
                  </v-tooltip>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="show = false">
          {{ $vuetify.lang.t('$vuetify.CLOSE') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  name: 'VehicleGroupLicensePlatesDialog',
  props: {
    visible: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data() {
    return {
      importedLicensePlates: [],
      licensePlateInEditMode: undefined,
      newLicensePlate: '',
      removePlatesNotInRequest: false
    }
  },
  computed: {
    ...mapGetters('vehicleGroups', ['vehicleGroupLicensePlates']),
    ...mapGetters('enforcement', ['selectedParkingFineReportingTask']),
    show: {
      get() {
        return this.visible
      },
      set(value) {
        if (!value) {
          this.setVehicleGroupLicensePlates([])
          this.setSelectedParkingFineReportingTask(undefined)
          this.$emit('close')
        }
      }
    }
  },
  watch: {},
  mounted() {
    this.getVehicleGroupLicensePlates(
      this.selectedParkingFineReportingTask.vehicleGroupId
    )
  },
  methods: {
    ...mapActions('vehicleGroups', [
      'getVehicleGroupLicensePlates',
      'postVehicleGroupLicensePlates',
      'putVehicleGroupLicensePlate',
      'deleteVehicleGroupLicensePlate'
    ]),
    ...mapMutations('enforcement', ['setSelectedParkingFineReportingTask']),
    ...mapMutations('vehicleGroups', ['setVehicleGroupLicensePlates']),
    async onFileSelect(files) {
      if (this.importedLicensePlates.length) {
        this.importedLicensePlates = []
      }
      await files.body.forEach(plate => {
        this.importedLicensePlates.push({
          licensePlate: plate.LicensePlate,
          vehicleGroupId: this.selectedParkingFineReportingTask.vehicleGroupId
        })
      })
      let importedLicensePlatesString = ''
      this.importedLicensePlates.forEach(element => {
        importedLicensePlatesString += `${element.licensePlate}, `
      })
      this.$confirm(
        `${this.$vuetify.lang.t(
          '$vuetify.VEHICLE_GROUPS.LICENSE_PLATE_IMPORT_WARNING_MESSAGE'
        )} ${importedLicensePlatesString}`,
        {
          title: this.$vuetify.lang.t('$vuetify.ARE_YOU_SURE'),
          color: 'error',
          icon: 'mdi-alert',
          persistent: true,
          buttonTrueText: this.$vuetify.lang.t('$vuetify.YES'),
          buttonFalseText: this.$vuetify.lang.t('$vuetify.CANCEL')
        }
      ).then(async option => {
        if (option) {
          this.postVehicleGroupLicensePlates({
            this: this,
            licensePlates: this.importedLicensePlates,
            vehicleGroupId: this.selectedParkingFineReportingTask
              .vehicleGroupId,
            removePlatesNotInRequest: this.removePlatesNotInRequest
          })
        }
      })
    },
    cancelEdit() {
      this.licensePlateInEditMode = undefined
    },
    async saveLicensePlate(item) {
      const plateNumber = this.$refs.licensePlateInput[0].$refs.input.value
      const success = await this.putVehicleGroupLicensePlate({
        this: this,
        ID: item.ID,
        licensePlate: plateNumber,
        vehicleGroupId: item.vehicleGroupId
      })
      if (success) {
        this.licensePlateInEditMode = undefined
      }
    },
    onLicensePlateDeleteClick(item) {
      this.$confirm(
        `${this.$vuetify.lang.t(
          '$vuetify.VEHICLE_GROUPS.LICENSE_PLATE_DELETE_WARNING_MESSAGE'
        )} ${item.licensePlate}`,
        {
          title: this.$vuetify.lang.t('$vuetify.ARE_YOU_SURE'),
          color: 'error',
          icon: 'mdi-alert',
          persistent: true,
          buttonTrueText: this.$vuetify.lang.t('$vuetify.YES'),
          buttonFalseText: this.$vuetify.lang.t('$vuetify.CANCEL')
        }
      ).then(async option => {
        if (option) {
          this.deleteVehicleGroupLicensePlate({
            this: this,
            vehicleGroupId: item.vehicleGroupId,
            ID: item.ID
          })
        }
      })
    },
    async addLicensePlate() {
      if (this.newLicensePlate) {
        const licensePlatesArray = this.newLicensePlate
          .split(',')
          .map(plate => plate.trim())
          .filter(plate => plate.length > 0)

        const licensePlates = licensePlatesArray.map(licensePlate => ({
          licensePlate
        }))

        const success = await this.postVehicleGroupLicensePlates({
          this: this,
          vehicleGroupId: this.selectedParkingFineReportingTask.vehicleGroupId,
          licensePlates,
          removePlatesNotInRequest: this.removePlatesNotInRequest
        })

        if (success) {
          this.newLicensePlate = ''
        }
      }
    },
    downloadTemplateFile() {
      const a = document.createElement('a')
      a.href =
        'https://admin.barking.ee/static/vehicle_group_license_plate_import_template.xlsx'
      a.setAttribute(
        'download',
        'vehicle_group_license_plate_import_template.xlsx'
      )
      a.click()
    }
  }
}
</script>

<style>
.xlsx-button {
  background-color: transparent;
  border: none;
}
</style>
